import * as qs from 'query-string';
import { useLocation } from 'react-router-dom';

import { MainContainer } from '@britishcouncil/react-solas-ors3';

import { ActivationForm, OnlyCompleteMigration, SimpleActivation } from './components';

type MigrationWithActivationType = {
  token: string;
  email: string;
  cp: 'true';
  mig: 'true';
  cId: string;
};

type MigrationWithoutActivationType = {
  cp: undefined;
  mig: 'true';
  cId: string;
};

type ActivationWithoutChangePasswordType = {
  token: string;
  email: string;
  cp: undefined;
  mig: undefined;
};

type ActivationWithChangePasswordType = {
  token: string;
  email: string;
  cp: 'true';
  mig: undefined;
};

export const AccountActivation = () => {
  const location = useLocation();

  const header = (
    <MainContainer>
      <h1>Account activation</h1>
    </MainContainer>
  );

  const queryParams = qs.parse(location.search) as
    | MigrationWithActivationType
    | MigrationWithoutActivationType
    | ActivationWithoutChangePasswordType
    | ActivationWithChangePasswordType;

  const changePassword = queryParams.cp === 'true';
  const isMigration = queryParams.mig === 'true';

  if (!changePassword && isMigration)
    return (
      <>
        {header}
        <OnlyCompleteMigration candidateId={+queryParams.cId} />
      </>
    );

  if (!changePassword && !isMigration)
    return (
      <>
        {header}
        <SimpleActivation token={queryParams.token} email={queryParams.email} />
      </>
    );

  if (isMigration) {
    return (
      <>
        {header}
        <ActivationForm
          token={queryParams.token}
          email={queryParams.email}
          isMigration={isMigration}
          candidateId={+queryParams.cId}
        />
      </>
    );
  }

  return (
    <>
      {header}
      <ActivationForm token={queryParams.token} email={queryParams.email} isMigration={isMigration} />
    </>
  );
};
